module.exports = __webpack_public_path__ + "img/logo.f5ec39a2.png";